import { useJobName } from "@/components/JobSelect/useCrowdTag";
import { getJobList } from "@/services";
import useReq from "@/utils/useReq";
import { useMemo } from "react";

export function useJobList({ manual = false } = {}) {
  const { data: list, runAsync } = useReq(getJobList, {
    cacheKey: "Job_List",
    staleTime: -1,
    cacheTime: -1,
    manual: manual,
  });

  return {
    data: list || [],
    run: runAsync,
  };
}

/**
 * 认证设计师类型
 * @param {{
 *   manual: boolean
 * }=} option
 * @returns
 */
export function useMuseCategories(option = {}) {
  const { data: jobs, run } = useJobList(option);
  const museCategories = useMemo(() => {
    return [
      ...jobs,
      { code: "company", category: "企业", id: 999, name: "企业" },
    ];
  }, [jobs]);

  return {
    data: museCategories || [],
    run,
  };
}

export function useUserJobName(user) {
  const { data: categories } = useMuseCategories();

  const userJob = useJobName(user);

  return useMemo(() => {
    if (user?.extra?.is_museuser) {
      const code = user?.museUser?.category[0];

      const name =
        user?.museUser?.category[0] === "company"
          ? user?.museUser.name
          : categories.find((category) => category.code === code)?.name;
      return name || "认证设计师";
    } else {
      return userJob;
    }
  }, [user, categories, userJob]);
}
